// Any address that does not exist used to serve the homepage with a 200, so a
// typo looked like the site had silently moved you, and a crawler saw the same
// homepage under hundreds of addresses. This says what happened and points
// straight back at the games.

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import './Guides.css';

const GAMES = [
  { to: '/quiz', label: 'Character Quiz', note: 'name the character from one picture' },
  { to: '/image-quiz', label: 'Image Quiz', note: 'pick the face that matches the name' },
  { to: '/devil-fruit-quiz', label: 'Devil Fruit Quiz', note: 'name the user behind every fruit' },
  { to: '/bounty-battle', label: 'Bounty Battle', note: 'guess which pirate is worth more' },
];

const NotFound = () => {
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  return (
    <>
      <Helmet>
        <title>Page Not Found | One Piece Trivia</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
        <div className="guide-container" style={{ textAlign: 'center' }}>
          <h1>This page does not exist</h1>
          <p className="guide-intro">
            The address is wrong or the page has moved. The games are all still here.
          </p>

          <ul className="seo-links" style={{ textAlign: 'left', maxWidth: '520px', margin: '0 auto 24px' }}>
            {GAMES.map((game) => (
              <li key={game.to}>
                <Link to={game.to}>{game.label}</Link> — {game.note}
              </li>
            ))}
            <li><Link to="/leaderboard">Leaderboard</Link> — see the top run in every game</li>
            <li><Link to="/characters">Character Archive</Link> — profiles, bounties and Devil Fruits</li>
          </ul>

          <Link to="/" className="guide-cta-button">Back to the games</Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
